// @flow

import {
  createUnauthenticatedHttpClient,
  localiseUrl
} from 'src/modules/seek-api-request';
import { eventCaptureUrl } from 'src/config';

export const putToEventCapture = ({
  locale,
  eventName,
  event
}: {
  locale: Locale,
  eventName: string,
  event: any
}): Promise<void> => {
  return createUnauthenticatedHttpClient().send({
    method: 'put',
    timeout: 8000, // Avg 5600, so use maximum of 8000
    url: localiseUrl(locale, eventCaptureUrl) + eventName,
    data: event,
    label: 'event-capture-proxy',
    withCredentials: true
  });
};
